import { type FC, type PropsWithChildren, useRef } from "react";

import { createFileSearchStore, FileSearchContext } from "@/modules/files/stores/file-search.ts";

export const FileSearchProvider: FC<PropsWithChildren> = ({ children }) => {
  const store = useRef(createFileSearchStore()).current;

  return <FileSearchContext.Provider value={store}>{children}</FileSearchContext.Provider>;
};
